import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for PWA install + app-shell caching (v5 Stage 2).
// Registered at root scope so it covers the whole app. Registration is deferred
// to the load event so it doesn't contend with first paint. Failures are
// non-fatal and logged only — the app works fine without the SW, the user just
// doesn't get install/offline-shell behavior.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("Service worker registration failed:", err);
    });
  });
}
